import { render } from "./CertBizStats.vue?vue&type=template&id=5d0fb6cc"
import script from "./CertBizStats.vue?vue&type=script&lang=js"
export * from "./CertBizStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__